import i18n from '@/i18n';

import {
  getTemplateCharts as getProductTemplateCharts,
  getTemplateDescription as getProductTemplateDescription,
  getTemplateLayout as getProductTemplateLayout,
  getTemplateName as getProductTemplateName,
  TEMPLATE_ID as PRODUCT_TEMPLATE_ID,
} from '../templates/product-sentiment-topic/constants';
import { productSentimentFormConfig } from '../templates/product-sentiment-topic/form';
import type { BaseFormValues, DashboardTemplate, TemplateFormConfig } from './types';

/** i18n namespace를 로드한 뒤 현재 언어에 맞는 템플릿 목록 반환 */
export const getDashboardTemplates = async (): Promise<DashboardTemplate[]> => {
  await i18n.loadNamespaces('dashboard-template');
  const t = i18n.getFixedT(null, 'dashboard-template');
  const productFormConfig =
    productSentimentFormConfig as unknown as TemplateFormConfig<BaseFormValues>;

  return [
    {
      id: PRODUCT_TEMPLATE_ID,
      name: getProductTemplateName(t),
      description: getProductTemplateDescription(t),
      charts: getProductTemplateCharts(t),
      layout: getProductTemplateLayout(t),
      formConfig: productFormConfig,
    },
  ];
};
